/* apps/fourcomply-dashboard/src/app/shared/components/ai-panel/ai-panel.component.scss */
.ai-panel-overlay {
  position: fixed;
  top: 70px;
  left: 280px;
  right: 0;
  bottom: 0;
  background: #f9fafb;
  z-index: 900;
  pointer-events: none;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0s 0.3s;
}
.ai-panel-overlay.open {
  pointer-events: auto;
  opacity: 1;
  visibility: visible;
  transition: opacity 0.3s ease, visibility 0s 0s;
}
.ai-panel {
  position: fixed;
  top: 70px;
  left: 280px;
  right: 0;
  bottom: 0;
  background: #fff;
  display: flex;
  flex-direction: column;
  z-index: 950;
  transform: translateX(-100%);
  visibility: hidden;
  transition:
    transform 0.3s cubic-bezier(0.4, 0, 0.2, 1),
    right 0.3s cubic-bezier(0.4, 0, 0.2, 1),
    visibility 0s 0.3s;
}
.ai-panel.with-preview {
  right: calc((100vw - 280px) / 2);
  border-right: 1px solid #e0e0e0;
}
.ai-panel.open {
  transform: translateX(0);
  visibility: visible;
  transition:
    transform 0.3s cubic-bezier(0.4, 0, 0.2, 1),
    right 0.3s cubic-bezier(0.4, 0, 0.2, 1),
    visibility 0s 0s;
}
.ai-panel-header {
  padding: 14px 20px;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background:
    linear-gradient(
      135deg,
      #61778f 0%,
      #4b5c6f 100%);
  color: white;
  flex-shrink: 0;
}
.ai-header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}
.ai-header-sparkle {
  font-size: 18px;
  filter: drop-shadow(0 0 4px rgba(255, 255, 255, 0.6));
  animation: ai-sparkle-white 3s ease-in-out infinite;
}
.ai-header-title {
  font-weight: 700;
  font-size: 16px;
}
.ai-header-actions {
  display: flex;
  align-items: center;
  gap: 2px;
}
.ai-header-btn {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  border: none;
  background: transparent;
  color: rgba(255, 255, 255, 0.8);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  transition: all 0.15s;
}
.ai-header-btn:hover {
  background: rgba(255, 255, 255, 0.15);
  color: white;
}
.ai-header-btn.active {
  background: rgba(255, 255, 255, 0.2);
  color: white;
}
.ai-context-badge {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background:
    linear-gradient(
      135deg,
      #e8f5e9,
      #c8e6c9);
  border-bottom: 1px solid #a5d6a7;
  font-size: 12px;
  color: #2e7d32;
}
.ai-context-badge i {
  font-size: 13px;
}
.ai-context-badge .ai-context-label {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ai-context-badge .ai-context-label strong {
  font-weight: 600;
}
.ai-context-badge .ai-context-mode-tag {
  background: #2e7d32;
  color: #fff;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  flex-shrink: 0;
}
.ai-token-dropdown-wrapper {
  position: relative;
}
.ai-token-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 8px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  padding: 12px 14px;
  min-width: 200px;
  z-index: 10;
  animation: ai-dropdown-in 0.15s ease-out;
}
.ai-token-dropdown::before {
  content: "";
  position: absolute;
  top: -5px;
  right: 12px;
  width: 10px;
  height: 10px;
  background: white;
  transform: rotate(45deg);
  box-shadow: -2px -2px 4px rgba(0, 0, 0, 0.04);
}
.ai-token-dropdown-title {
  font-size: 11px;
  font-weight: 700;
  color: #7c4dff;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 6px;
}
.ai-token-dropdown-title i {
  font-size: 12px;
}
.ai-token-dropdown-stats {
  display: flex;
  align-items: center;
  gap: 0;
}
.ai-token-dropdown-stat {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 10px;
}
.ai-token-dropdown-label {
  font-size: 9px;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  line-height: 1;
}
.ai-token-dropdown-value {
  font-size: 14px;
  font-weight: 700;
  color: #333;
  line-height: 1.4;
}
.ai-token-dropdown-reset {
  background: none;
  border: none;
  color: #aaa;
  font-size: 9px;
  cursor: pointer;
  padding: 2px 4px;
  border-radius: 3px;
  transition: all 0.15s;
}
.ai-token-dropdown-reset:hover {
  color: #7c4dff;
  background: rgba(124, 77, 255, 0.08);
}
.ai-token-dropdown-divider {
  width: 1px;
  height: 24px;
  background: #e0e0e0;
}
.ai-sessions-list {
  max-height: 200px;
  overflow-y: auto;
  border-bottom: 1px solid #e5e7eb;
  padding: 8px;
  flex-shrink: 0;
}
.ai-session-empty {
  text-align: center;
  color: #9ca3af;
  font-size: 12px;
  padding: 12px;
}
.ai-session-item {
  padding: 8px 12px;
  cursor: pointer;
  border-radius: 6px;
  font-size: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: background-color 0.15s;
}
.ai-session-item:hover {
  background: #f3f4f6;
}
.ai-session-item.active {
  background: rgba(97, 119, 143, 0.1);
  color: #4b5c6f;
}
.ai-session-item .session-title {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ai-session-item .session-delete {
  width: 20px;
  height: 20px;
  border: none;
  background: transparent;
  cursor: pointer;
  color: #9ca3af;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  font-size: 10px;
  flex-shrink: 0;
}
.ai-session-item .session-delete:hover {
  color: #ef4444;
  background: #fef2f2;
}
.ai-messages {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background: #f9fafb;
}
.ai-messages::-webkit-scrollbar {
  width: 6px;
}
.ai-messages::-webkit-scrollbar-track {
  background: transparent;
}
.ai-messages::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 3px;
}
.ai-empty-state {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: #6b7280;
}
.ai-empty-icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: rgba(97, 119, 143, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
}
.ai-empty-icon i {
  background:
    linear-gradient(
      135deg,
      #4285f4 0%,
      #9b72f2 25%,
      #d96570 50%,
      #f6a045 75%,
      #34a853 100%);
  background-size: 200% 200%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  animation: ai-gradient-empty 8s linear infinite, ai-sparkle-white 3s ease-in-out infinite;
}
.ai-empty-title {
  font-size: 16px;
  font-weight: 600;
  color: #374151;
}
.ai-empty-subtitle {
  font-size: 13px;
  text-align: center;
  padding: 0 16px;
  color: #9ca3af;
}
.ai-quick-prompts {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
  margin-top: 8px;
}
.ai-quick-btn {
  padding: 6px 12px;
  border-radius: 8px;
  border: 1px solid #d0d5dd;
  background: white;
  color: #4b5c6f;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.15s;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.ai-quick-btn:hover {
  background: #f3f4f6;
  border-color: #9ca3af;
}
.ai-msg-row {
  display: flex;
  gap: 10px;
  align-items: flex-start;
}
.ai-msg-row.user {
  flex-direction: row-reverse;
}
.ai-msg-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}
.assistant .ai-msg-avatar {
  background: rgba(97, 119, 143, 0.15);
  color: #4b5c6f;
}
.user .ai-msg-avatar {
  background: #61778f;
  color: white;
}
.ai-msg-content {
  max-width: 82%;
}
.ai-msg-bubble {
  padding: 10px 14px;
  font-size: 13px;
  line-height: 1.6;
  word-wrap: break-word;
}
.user .ai-msg-bubble {
  background: #61778f;
  color: white;
  border-radius: 12px 12px 4px 12px;
}
.assistant .ai-msg-bubble {
  background: white;
  color: #374151;
  border-radius: 12px 12px 12px 4px;
  border: 1px solid #e5e7eb;
}
.ai-msg-bubble pre {
  background: #f3f4f6;
  padding: 8px;
  border-radius: 6px;
  overflow-x: auto;
  font-size: 12px;
  margin: 6px 0;
}
.ai-msg-bubble code {
  font-size: 12px;
}
.ai-msg-bubble ::ng-deep .ai-cards-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  padding-bottom: 6px;
  border-bottom: 2px solid #e0e0e0;
}
.ai-msg-bubble ::ng-deep .ai-cards-header strong {
  font-size: 13px;
  color: #1e293b;
}
.ai-msg-bubble ::ng-deep .ai-cards-header .ai-cards-count {
  font-size: 11px;
  color: #64748b;
  background: #f1f5f9;
  padding: 2px 8px;
  border-radius: 10px;
  font-weight: 500;
}
.ai-msg-bubble ::ng-deep .ai-cards-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.ai-msg-bubble ::ng-deep .ai-card {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 10px 12px;
  position: relative;
}
.ai-msg-bubble ::ng-deep .ai-card .ai-card-number {
  position: absolute;
  top: 8px;
  right: 10px;
  font-size: 10px;
  font-weight: 700;
  color: #94a3b8;
}
.ai-msg-bubble ::ng-deep .ai-card-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 3px 0;
  gap: 8px;
}
.ai-msg-bubble ::ng-deep .ai-card-row:not(:last-child) {
  border-bottom: 1px solid #f1f5f9;
}
.ai-msg-bubble ::ng-deep .ai-card-row .ai-card-label {
  font-size: 11px;
  color: #64748b;
  font-weight: 500;
  flex-shrink: 0;
  min-width: 90px;
}
.ai-msg-bubble ::ng-deep .ai-card-row .ai-card-value {
  font-size: 11px;
  color: #1e293b;
  text-align: right;
  word-break: break-word;
}
.ai-msg-bubble ::ng-deep .ai-reg-detail {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.ai-msg-bubble ::ng-deep .ai-reg-header {
  padding-bottom: 8px;
  border-bottom: 2px solid #e0e0e0;
}
.ai-msg-bubble ::ng-deep .ai-reg-name {
  font-size: 15px;
  font-weight: 700;
  color: #1e293b;
}
.ai-msg-bubble ::ng-deep .ai-reg-fullname {
  font-size: 12px;
  color: #64748b;
  margin-top: 2px;
}
.ai-msg-bubble ::ng-deep .ai-reg-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 6px;
}
.ai-msg-bubble ::ng-deep .ai-reg-badge {
  font-size: 10px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 10px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}
.ai-msg-bubble ::ng-deep .ai-reg-badge.enabled {
  background: #dcfce7;
  color: #166534;
}
.ai-msg-bubble ::ng-deep .ai-reg-badge.disabled {
  background: #fee2e2;
  color: #991b1b;
}
.ai-msg-bubble ::ng-deep .ai-reg-priority {
  font-size: 11px;
  color: #64748b;
}
.ai-msg-bubble ::ng-deep .ai-reg-note {
  font-size: 11px;
  color: #475569;
  margin-top: 4px;
  font-style: italic;
}
.ai-msg-bubble ::ng-deep .ai-reg-section {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.ai-msg-bubble ::ng-deep .ai-reg-section-title {
  font-size: 12px;
  font-weight: 700;
  color: #334155;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 0;
  border-bottom: 1px solid #e2e8f0;
}
.ai-msg-bubble ::ng-deep .ai-reg-section-title i {
  font-size: 11px;
  color: #61778f;
}
.ai-msg-bubble ::ng-deep .ai-report-table {
  width: 100%;
  border-collapse: collapse;
  margin: 8px 0;
  font-size: 12px;
}
.ai-msg-bubble ::ng-deep .ai-report-table th {
  background: #f0f4ff;
  color: #475569;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  padding: 8px 10px;
  text-align: left;
  border-bottom: 2px solid #e0e0e0;
}
.ai-msg-bubble ::ng-deep .ai-report-table td {
  padding: 6px 10px;
  border-bottom: 1px solid #f1f1f1;
  color: #4b5563;
}
.ai-msg-bubble ::ng-deep .ai-report-table tr:hover td {
  background: #f8fafc;
}
.ai-msg-bubble ::ng-deep .ai-report-table tr:nth-child(even) td {
  background: #fafbff;
}
.ai-msg-time {
  font-size: 10px;
  color: #9ca3af;
  margin-top: 4px;
}
.user .ai-msg-time {
  text-align: right;
}
.ai-typing {
  display: flex;
  gap: 4px;
  padding: 4px 0;
}
.ai-typing span {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #9ca3af;
  animation: ai-typing 1.2s infinite;
}
.ai-typing span:nth-child(2) {
  animation-delay: 0.2s;
}
.ai-typing span:nth-child(3) {
  animation-delay: 0.4s;
}
.ai-preview-inline {
  border-top: 1px solid #e5e7eb;
  flex-shrink: 0;
  max-height: 400px;
  display: flex;
  flex-direction: column;
}
.ai-preview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  background: #f3f4f6;
  font-size: 13px;
  font-weight: 600;
  color: #374151;
}
.ai-preview-actions {
  padding: 8px 16px;
  text-align: right;
  border-top: 1px solid #e5e7eb;
}
.ai-confirm-btn {
  padding: 8px 16px;
  border-radius: 8px;
  border: none;
  background: #61778f;
  color: white;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.ai-confirm-btn:hover {
  background: #4b5c6f;
}
.ai-data-preview {
  border-top: 1px solid #e5e7eb;
  flex-shrink: 0;
  max-height: 45%;
  display: flex;
  flex-direction: column;
  background: white;
}
.ai-data-preview .ai-preview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  background:
    linear-gradient(
      135deg,
      #f0f4ff 0%,
      #e8f0fe 100%);
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  border-bottom: 1px solid #e0e0e0;
}
.ai-data-preview .ai-preview-header-actions {
  display: flex;
  align-items: center;
  gap: 4px;
}
.ai-export-btn {
  padding: 4px 10px;
  border-radius: 6px;
  border: 1px solid #61778f;
  background: white;
  color: #61778f;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  transition: all 0.15s;
}
.ai-export-btn:hover {
  background: #61778f;
  color: white;
}
.ai-data-table-wrap {
  flex: 1;
  overflow: auto;
}
.ai-data-table-wrap::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
.ai-data-table-wrap::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 3px;
}
.ai-data-table {
  width: max-content;
  min-width: 100%;
  border-collapse: collapse;
  font-size: 11px;
}
.ai-data-table th {
  position: sticky;
  top: 0;
  background: #f8fafc;
  color: #475569;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  padding: 6px 10px;
  text-align: left;
  border-bottom: 2px solid #e0e0e0;
  white-space: nowrap;
  font-size: 10px;
  z-index: 1;
}
.ai-data-table td {
  padding: 5px 10px;
  border-bottom: 1px solid #f1f5f9;
  color: #374151;
  white-space: nowrap;
}
.ai-data-table tr:hover td {
  background: #f0f4ff;
}
.ai-data-table tr:nth-child(even) td {
  background: #fafbff;
}
.ai-data-table tr:hover:nth-child(even) td {
  background: #f0f4ff;
}
.ai-msg-bubble ::ng-deep .ai-open-preview-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  margin-top: 8px;
  border-radius: 8px;
  border: 1px solid #61778f;
  background: white;
  color: #61778f;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
}
.ai-msg-bubble ::ng-deep .ai-open-preview-btn:hover {
  background: #61778f;
  color: white;
}
.ai-preview-side-panel {
  position: fixed;
  top: 70px;
  left: calc(280px + (100vw - 280px) / 2);
  right: 0;
  bottom: 0;
  background: #fff;
  display: flex;
  flex-direction: column;
  z-index: 940;
  opacity: 0;
  visibility: hidden;
  transform: translateX(20px);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.25s ease;
}
.ai-preview-side-panel.open {
  transform: translateX(0);
  opacity: 1;
  visibility: visible;
}
.ai-preview-side-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  background:
    linear-gradient(
      135deg,
      #f5f5f5,
      #eeeeee);
  border-bottom: 1px solid #e0e0e0;
  font-size: 13px;
  font-weight: 700;
  color: #374151;
  flex-shrink: 0;
}
.ai-preview-side-header .ai-preview-side-header-actions {
  display: flex;
  align-items: center;
  gap: 6px;
}
.ai-preview-tab-btn {
  background: none;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 3px 8px;
  font-size: 11px;
  cursor: pointer;
  color: #666;
  transition: all 0.15s ease;
}
.ai-preview-tab-btn.active {
  background: #61778f;
  color: #fff;
  border-color: #61778f;
}
.ai-preview-tab-btn:hover:not(.active) {
  background: #eee;
}
.ai-preview-side-close {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  border: none;
  background: transparent;
  color: #888;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  transition: all 0.15s;
}
.ai-preview-side-close:hover {
  background: #e0e0e0;
  color: #333;
}
.ai-preview-side-content {
  flex: 1;
  overflow: auto;
  background: #fafafa;
  position: relative;
}
.ai-preview-side-iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
  background: #fff;
}
.ai-preview-side-code {
  margin: 0;
  padding: 14px 16px;
  font-size: 12px;
  font-family:
    "Fira Code",
    "Cascadia Code",
    "Consolas",
    monospace;
  background: #1e1e2e;
  color: #cdd6f4;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-all;
  min-height: 100%;
}
.ai-preview-side-actions {
  display: flex;
  gap: 8px;
  padding: 10px 16px;
  border-top: 1px solid #e0e0e0;
  background: #f5f5f5;
  flex-shrink: 0;
}
.ai-apply-btn {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 12px;
  border: none;
  border-radius: 6px;
  background: #2e7d32;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease;
}
.ai-apply-btn:hover {
  background: #1b5e20;
}
.ai-reject-btn {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  background: #fff;
  color: #666;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
}
.ai-reject-btn:hover {
  background: #ffebee;
  border-color: #ef9a9a;
  color: #c62828;
}
.ai-applied-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  background: #e8f5e9;
  color: #2e7d32;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}
.ai-applied-badge i {
  font-size: 13px;
}
.ai-suggestion-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 8px 16px;
  border-top: 1px solid #f3f4f6;
  background: #fafbfc;
  flex-shrink: 0;
}
.ai-suggestion-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 14px;
  border: 1px solid #e5e7eb;
  background: white;
  color: #4b5563;
  font-size: 11px;
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;
}
.ai-suggestion-chip i {
  font-size: 10px;
}
.ai-suggestion-chip.preference i {
  color: #8b5cf6;
}
.ai-suggestion-chip.preference:hover {
  background: #f5f3ff;
  border-color: #c4b5fd;
  color: #6d28d9;
}
.ai-suggestion-chip.contact i {
  color: #0ea5e9;
}
.ai-suggestion-chip.contact:hover {
  background: #f0f9ff;
  border-color: #7dd3fc;
  color: #0369a1;
}
.ai-suggestion-chip:hover {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}
.ai-input-area {
  padding: 12px 16px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: white;
  flex-shrink: 0;
}
.ai-attached-images {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.ai-attached-thumb {
  position: relative;
  width: 48px;
  height: 48px;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #d1d5db;
}
.ai-attached-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.ai-attached-thumb .ai-thumb-remove {
  position: absolute;
  top: 2px;
  right: 2px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: none;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  font-size: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  opacity: 0;
  transition: opacity 0.15s;
}
.ai-attached-thumb:hover .ai-thumb-remove {
  opacity: 1;
}
.ai-input-row {
  display: flex;
  gap: 6px;
  align-items: flex-end;
}
.ai-input-wrapper {
  position: relative;
  flex: 1;
}
.ai-input-wrapper textarea {
  width: 100%;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  padding: 10px 14px;
  font-size: 13px;
  resize: none;
  max-height: 120px;
  outline: none;
  transition: border-color 0.15s;
  background: white;
  color: #374151;
  font-family: inherit;
  box-sizing: border-box;
}
.ai-input-wrapper textarea:focus {
  border-color: #61778f;
}
.ai-input-wrapper textarea:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.ai-autocomplete {
  position: absolute;
  bottom: 100%;
  left: 0;
  right: 0;
  margin-bottom: 4px;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  max-height: 200px;
  overflow-y: auto;
  z-index: 10;
}
.ai-autocomplete-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 8px 12px;
  border: none;
  background: none;
  cursor: pointer;
  transition: background 0.1s;
  text-align: left;
}
.ai-autocomplete-item:hover,
.ai-autocomplete-item.active {
  background: #f3f4f6;
}
.ai-autocomplete-item:first-child {
  border-radius: 10px 10px 0 0;
}
.ai-autocomplete-item:last-child {
  border-radius: 0 0 10px 10px;
}
.ai-autocomplete-item:only-child {
  border-radius: 10px;
}
.ai-autocomplete-label {
  font-size: 13px;
  color: #1f2937;
  font-weight: 500;
}
.ai-autocomplete-detail {
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: 500;
}
.ai-autocomplete-detail.cat-preference {
  color: #7c3aed;
  background: #f5f3ff;
}
.ai-autocomplete-detail.cat-contact {
  color: #0284c7;
  background: #f0f9ff;
}
.ai-autocomplete-detail.cat-business-unit {
  color: #059669;
  background: #ecfdf5;
}
.ai-input-action-btn {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid #d1d5db;
  background: white;
  color: #6b7280;
  cursor: pointer;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  transition: all 0.15s;
}
.ai-input-action-btn:hover {
  background: #f3f4f6;
  border-color: #9ca3af;
  color: #374151;
}
.ai-input-action-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.ai-speech-btn.listening {
  background: #ef4444;
  border-color: #ef4444;
  color: white;
  animation: ai-pulse-mic 1.2s ease-in-out infinite;
}
.ai-speech-btn.listening:hover {
  background: #dc2626;
  border-color: #dc2626;
  color: white;
}
.ai-send-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  background: #61778f;
  color: white;
  cursor: pointer;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  transition: all 0.15s;
}
.ai-send-btn:hover {
  background: #4b5c6f;
}
.ai-send-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
@keyframes ai-sparkle-white {
  0%, 100% {
    opacity: 1;
    transform: scale(1) rotate(0deg);
  }
  33% {
    opacity: 0.85;
    transform: scale(1.1) rotate(8deg);
  }
  66% {
    opacity: 0.85;
    transform: scale(1.1) rotate(-8deg);
  }
}
@keyframes ai-gradient-empty {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
@keyframes ai-typing {
  0%, 60%, 100% {
    opacity: 0.3;
    transform: scale(0.8);
  }
  30% {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes ai-pulse-mic {
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.4);
  }
  50% {
    box-shadow: 0 0 0 6px rgba(239, 68, 68, 0);
  }
}
@keyframes ai-dropdown-in {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.agent-confirmation-card {
  margin: 8px 12px;
  padding: 12px;
  background: var(--bg-card, #1e293b);
  border: 1px solid var(--border-color, rgba(255, 255, 255, 0.1));
  border-left: 3px solid #f59e0b;
  border-radius: 8px;
}
.agent-confirmation-card .agent-confirmation-header {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  color: #f59e0b;
  margin-bottom: 8px;
  font-size: 13px;
}
.agent-confirmation-card .agent-confirmation-header i {
  font-size: 14px;
}
.agent-confirmation-card .agent-confirmation-summary {
  font-size: 12.5px;
  line-height: 1.5;
  color: var(--text-secondary, rgba(255, 255, 255, 0.7));
  margin-bottom: 12px;
  white-space: pre-wrap;
}
.agent-confirmation-card .agent-confirmation-actions {
  display: flex;
  gap: 8px;
}
.agent-confirmation-card .agent-confirmation-actions button {
  flex: 1;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: all 0.15s ease;
}
.agent-confirmation-card .agent-confirmation-actions button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
/*# sourceMappingURL=ai-panel.component.css.map */
